import storageSession from 'redux-persist/lib/storage/session'

export const persistConfig = {
	key: 'root',
	// localStorage에 저장합니다.
	storage: storageSession,
	// 저장할 리스트
	whitelist: [
		// core
		'config',
		'route',
		'auth',
		'user',
		'department',
		'main',
		'grid',
		'masterdata',

		// main
		'admin',
		'logDashboard',
		'accessPolicy',
		'accessControl',
		'product',
		'season',
		'coupon',
		'customer',
		'order',

		// home
		'customerAuth',
		'shop',
		'cart',
		'payment',
		'inquiry',
	],
	blacklist: ['login'],
}
